module.exports = __webpack_public_path__ + "static/img/topbg-on.89eb37a7.png";